<template>
  <div>
    <!-- <div class="lorderFirst">
      <div
        class="lorderTitle"
        v-for="(item, index) in title"
        :key="item.key"
        @click="clickTitle(item.name, index)"
        :class="[{ active: activeName == item.name }]"
      >
        <div class="lorderTitleName">{{ item.name }}</div>
        <div :class="[{ lorderTitleBorder: activeName == item.name }]"></div>
      </div>
    </div> -->
    <div class="lorderCont" v-show="num == 1">
      <div class="lorderContTitle">订单详情</div>
      <div>
        <Form :label-width="80">
          <Row>
            <Col span="11">
              <FormItem label="" class="newForm">
                <p>订&nbsp;&nbsp;单&nbsp;&nbsp;号</p>
                <Input v-model="obj.orderNo" placeholder="请输入订单号" readonly></Input>
              </FormItem>
            </Col>
            <Col span="11">
              <FormItem label="" class="newForm">
                <p>项&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 目</p>
                <Input
                  v-model="obj.projectName"
                  placeholder="请输入项目名称"
                  readonly
                ></Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="11">
              <FormItem label="" class="newForm">
                <p>选择学时</p>
                <Input
                  v-model="obj.creditHour"
                  placeholder="请输入选择学时"
                  readonly
                ></Input>
              </FormItem>
            </Col>
            <Col span="11">
              <FormItem label="">
                <p>培&nbsp;&nbsp;训&nbsp;&nbsp;费</p>
                <Input
                  v-model="obj.trainPrice"
                  placeholder="请输入培训费"
                  readonly
                ></Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="11">
              <FormItem label="" class="newForm">
                <p>教&nbsp;&nbsp;材&nbsp;&nbsp;费</p>
                <Input
                  v-model="obj.bookPrice"
                  placeholder="请输入教材费"
                  readonly
                ></Input>
              </FormItem>
            </Col>
            <Col span="11">
              <FormItem label="">
                <p>邮&nbsp;&nbsp;寄&nbsp;&nbsp;费</p>
                <Input
                  v-model="obj.postPrice"
                  placeholder="请输入邮寄费"
                  readonly
                ></Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="11">
              <FormItem label="" class="newForm">
                <p>合计金额</p>
                <Input
                  v-model="obj.totalPrice"
                  placeholder="请输入合计金额"
                  readonly
                ></Input>
              </FormItem>
            </Col>
            <Col span="11">
              <FormItem label="">
                <p>交易金额</p>
                <Input
                  v-model="obj.transactionPrice"
                  placeholder="请输入交易金额"
                  readonly
                ></Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="11">
              <FormItem label="" class="newForm">
                <p>缴费方式</p>
                <Input v-model="fangshi" placeholder="缴费方式" readonly></Input>
              </FormItem>
            </Col>
            <Col span="11">
              <FormItem label="">
                <p>退&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;补</p>
                <Input v-model="total" placeholder="退补" readonly></Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="11">
              <FormItem label="" class="newForm">
                <p>快递单号</p>
                <Input
                  v-model="obj.trackNo"
                  placeholder="请输入快递单号"
                  readonly
                ></Input>
              </FormItem>
            </Col>
            <Col span="11">
              <FormItem label="">
                <p>状&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;态</p>
                <Input v-model="type" placeholder="状态" readonly></Input>
              </FormItem>
            </Col>
          </Row>
          <!-- <Row>
            <Col span="11">
              <FormItem label="">
                <p>修改报名</p>
                <Input v-model="xiugai" placeholder="状态"></Input>
              </FormItem>
            </Col>
          </Row> -->
        </Form>
      </div>
    </div>
    <div class="lorderCont" v-show="num == 2">
      <div class="lorderContTitle">订单详情</div>
      <div>
        <Form :model="formItem" :label-width="80">
          <Row>
            <Col span="11">
              <FormItem label="" class="newForm">
                <p>订&nbsp;&nbsp;单&nbsp;&nbsp;号</p>
                <Input
                  v-model="obj2.orderNo"
                  placeholder="请输入订单号"
                ></Input>
              </FormItem>
            </Col>
            <Col span="11">
              <FormItem label="">
                <p>企业名称</p>
                <Input
                  v-model="obj2.companyName"
                  placeholder="请输入企业名称"
                ></Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="11">
              <FormItem label="" class="newForm">
                <p>项&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 目</p>
                <Input
                  v-model="obj2.projectName"
                  placeholder="请输入项目名称"
                ></Input>
              </FormItem>
            </Col>
            <Col span="11">
              <FormItem label="">
                <p>报名人数</p>
                <Input
                  v-model="formItem.input"
                  placeholder="请输入报名人数"
                ></Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="11">
              <FormItem label="" class="newForm">
                <p>教&nbsp;&nbsp;材&nbsp;&nbsp;费</p>
                <Input
                  v-model="obj2.bookPrice"
                  placeholder="请输入教材费"
                ></Input>
              </FormItem>
            </Col>
            <Col span="11">
              <FormItem label="">
                <p>培&nbsp;&nbsp;训&nbsp;&nbsp;费</p>
                <Input
                  v-model="obj2.trainPrice"
                  placeholder="请输入培训费"
                ></Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="11">
              <FormItem label="" class="newForm">
                <p>合计金额</p>
                <Input
                  v-model="obj2.totalPrice"
                  placeholder="请输入合计金额"
                ></Input>
              </FormItem>
            </Col>
            <Col span="11">
              <FormItem label="">
                <p>邮&nbsp;&nbsp;寄&nbsp;&nbsp;费</p>
                <Input
                  v-model="obj2.postPrice"
                  placeholder="请输入邮寄费"
                ></Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="11">
              <FormItem label="" class="newForm">
                <p>缴费方式</p>
                <Input v-model="feifangshi" placeholder="缴费方式"></Input>
              </FormItem>
            </Col>
            <Col span="11">
              <FormItem label="">
                <p>交易金额</p>
                <Input
                  v-model="obj2.transactionPrice"
                  placeholder="请输入交易金额"
                ></Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="11">
              <FormItem label="" class="newForm">
                <p>快递单号</p>
                <Input
                  v-model="obj2.trackNo"
                  placeholder="请输入快递单号"
                ></Input>
              </FormItem>
            </Col>
            <Col span="11">
              <FormItem label="">
                <p>退&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;补</p>
                <Input v-model="formItem.input" placeholder="退补"></Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="11">
              <FormItem label="" class="newForm">
                <p>负责人姓名</p>
                <Input
                  v-model="obj2.fullName"
                  placeholder="请输入负责人姓名"
                ></Input>
              </FormItem>
            </Col>
            <Col span="11">
              <FormItem label="">
                <p>状&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;态</p>
                <Input v-model="type" placeholder="状态"></Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="11">
              <FormItem label="" class="newForm">
                <p>快递地址</p>
                <Input
                  v-model="obj2.address"
                  placeholder="请输入快递地址"
                ></Input>
              </FormItem>
            </Col>
            <Col span="11">
              <FormItem label="">
                <p>联系方式</p>
                <Input
                  v-model="obj2.mobile"
                  placeholder="请输入联系方式"
                ></Input>
              </FormItem>
            </Col>
          </Row>
        </Form>
      </div>
      <!--报名画册  -->
      <div>
        <div class="lorderContTitle">报名画册</div>
        <div class="lorderContTable">
          <div class="table">
            <Table border height="230" :columns="columns1" :data="data1">
              <template slot-scope="{ row }" slot="idCard">
                {{ codeSplice(row.idCard) }}
              </template>
            </Table>
          </div>
        </div>
      </div>
      <!-- 分页 -->
    </div>
  </div>
</template>
<script>
import { queryOrderDetail } from "../../../network/LPersonal";
import Cookies from "js-cookie";
export default {
  data() {
    return {
      // 表头
      formItem: {
        input: "",
      },
      num: "",
      fangshi: "",
      obj: {},
      total: "¥0.00",
      title: [
        { name: "个人订单管理", key: 0 },
        { name: "企业订单管理", key: 1 },
      ],
      activeName: "个人订单管理",
      columns1: [
        {
          title: "身份证号",
          key: "idCard",
          slot: "idCard",
          width: 220,
        },
        {
          title: "姓名",
          key: "fullName",
        },
        {
          title: "手机号",
          key: "mobile",
        },
        {
          title: "选报学时",
          key: "creditHour",
        },
      ],
      data1: [
        {
          idCard: "1121212112313213213232",
          fullName: "张三",
          mobile: "13257288990",
          creditHour: "50",
        },
      ],
      type: "",
      xiugai: "追加学分",
      obj2: {},
      feifangshi: "",
    };
  },
  created() {
    this.obj = JSON.parse(decodeURIComponent(this.$route.query.data));
    this.getFangshi();
    console.log(JSON.parse(decodeURIComponent(this.$route.query.data)));
    if (this.yearNum == "全部") {
      this.type = "";
    } else if (this.obj.status == 1) {
      this.type = "待支付";
    } else if (this.obj.status == 2) {
      this.type = "已退订";
    } else if (this.obj.status == 3) {
      this.type = "订单关闭";
    } else if (this.obj.status == 4) {
      this.type = "待审核退款";
    } else if (this.obj.status == 5) {
      this.type = "支付成功";
    }
    if (this.Get("type") == 1) {
      this.num = 2;
      this.activeName = "企业订单管理";
      this.queryOrderDetail();
    } else {
      this.num = 1;
      this.activeName = "个人订单管理";
    }
  },
  methods: {
    getFangshi() { // 获取缴费方式
      switch(this.obj.payChannel) {
        case 0:
          this.fangshi = "微信";
          break;
        case 1:
          this.fangshi = "支付宝";
          break;
        case 2:
          this.fangshi = "银行卡转账";
          break;
        case 3:
          this.fangshi = "线下";
          break;
        case 4:
          this.fangshi = "后台导入";
          break;
        case 5:
          this.fangshi = "线上支付";
          break;
      }
    },
    Get(name) {
      return Cookies.get(`admin-${name}`);
    },
    clickTitle(val, index) {
      this.activeName = val;
      this.num = index + 1;
    },
    codeSplice(idCard) {
      return idCard.substr(0, 6) + "************";
    },
    queryOrderDetail() {
      queryOrderDetail(this.obj.orderNo).then((res) => {
        const data = JSON.parse(decodeURIComponent(this.$route.query.data));
        console.log(res, "企业订单详情");
        this.obj2 = res.data.data;
        const addrss = this.obj2.userAddress;
        this.obj2.projectName = data.projectName;
        if(addrss) this.obj2.address = addrss.province + addrss.city + addrss.county + addrss.address;
        this.formItem.input = this.obj2.list.length;
        this.data1 = this.obj2.list;
        console.log(this.obj2);
        if (this.obj2.payChannel == 0) {
          this.feifangshi = "微信";
        } else if (this.obj2.payChannel == 1) {
          this.feifangshi = "支付宝";
        } else if (this.obj2.payChannel == 2) {
          this.feifangshi = "银行卡转账";
        } else if (this.obj2.payChannel == 3) {
          this.feifangshi = "线下";
        } else if (this.obj2.payChannel == 4) {
          this.feifangshi = "后台导入";
        }
      });
    },
  },
};
</script>
<style scope>
.lorderCont{
  margin-top: 0;
}
</style>